import type { TableColumnsType } from "antd";
import { Col, ConfigProvider, Row, Table } from "antd";
import ar_EG from "antd/lib/locale/ar_EG";
import "moment/locale/ar";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllBankAccounts,
  getBeneficiaryDetails,
} from "../../../../apis/actions/recipient.actions";
import { AppDispatch, RootState } from "../../../../apis/store";
import DotsLoader from "../../../../biblio/Loader/DotsLoader";
import PaginationComponent from "../../../../biblio/Pagination/PaginationComponent";
import { scroll } from "../../../../components/utils/utils";
import PrimaryButton from "../../../../biblio/Buttons/PrimaryButton";
import ModalComponent from "../../../../biblio/Modal/ModalComponent";
import BankAccountRequest from "./AddBankAccountModal";

const BankAccountList = () => {
  const dispatch = useDispatch<AppDispatch>();

  const currentRef = useRef<HTMLDivElement>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentData, setCurrentData] = useState<any[]>([]);
  const [data, setData] = useState<any[]>([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isAddedPermitted, setIsAddedPermitted] = useState(false);

  const beneficiaries = useSelector(
    (state: RootState) => state?.recipient?.beneficiaryDetails
  );
  const { loading, bankAccounts } = useSelector(
    (state: RootState) => state?.recipient
  );
  useEffect(() => {
    const fetchData = async () => {
      await dispatch(getAllBankAccounts());
      await dispatch(getBeneficiaryDetails());
    };
    fetchData();
  }, [dispatch]);
  useEffect(() => {
    if (!loading && beneficiaries?.person_ids) {
      const hasEligibleBeneficiary =
        Array.isArray(beneficiaries.person_ids) &&
        beneficiaries.person_ids.some(
          (person: any) =>
            person.beneficiary_state !== "dead" &&
            !bankAccounts.some(
              (account: any) => account.partner_id === person.id
            )
        );

      setIsAddedPermitted(hasEligibleBeneficiary);
    }
  }, [beneficiaries, bankAccounts, loading]);
  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };

  useEffect(() => {
    setData(bankAccounts);
    setCurrentData(bankAccounts);
  }, [loading, bankAccounts]);

  const columns: TableColumnsType<any> = [
    {
      title: "صاحب الحساب",
      dataIndex: "account_owner",
      render: (text: string) => (
        <b className="takaful--text-color-blue">
          <span>{text}</span>
        </b>
      ),
    },
    {
      title: "البنك",
      dataIndex: "bank_id",
  
    },
    {
      title: "رقم الحساب",
      dataIndex: "acc_number",
    },

  ];

  const itemPerPage = 8;

  return (
    <div className="takaful--sponsor-donation-payment">
      <ConfigProvider locale={ar_EG} direction="rtl">
        <Row
          gutter={8}
          dir="rtl"
          ref={currentRef}
          style={{marginBottom:"1rem"}}
          >
          <Col span={24}>
            <span className="takaful--service-section-title">
              الحسابات البنكية
            </span>
          </Col>
        </Row>
        <Row
          justify={"space-between"}
          className="takaful--request-col-space"
        >
          <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={12} style={{marginBottom:"2rem"}}>

          {isAddedPermitted && (
        <PrimaryButton
          onClick={() => setIsModalVisible(true)}
          title="إضافة حساب بنكي"
          className="takaful--add-request-btn"
        />
      )}

            </Col>

        </Row>
      </ConfigProvider>
      {loading ? (
        <div
          className="takaful--loading-projects-cases"
          style={{ minHeight: "20vh" }}
        >
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      ) : (
        <>
          <Table<any>
            style={{ direction: "rtl" }}
            columns={columns}
            dataSource={currentData.slice(
              (currentPage - 1) * itemPerPage,
              (currentPage - 1) * itemPerPage + itemPerPage
            )}
            className="takaful--sponsor-table"
            scroll={{ x: "max-content" }}
            pagination={false}
            locale={{
              emptyText: "لا يوجد حسابات",
            }}
          />
          {data && currentData.length > itemPerPage && (
            <PaginationComponent
              active={currentPage}
              total={currentData.length}
              itemPerPage={itemPerPage}
              scroll={() => scroll(currentRef)}
              setActive={(nb) => updateActive(nb)}
            />
          )}
        </>
      )}

      <ModalComponent
      
        title=""
        open={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        closeOnOutsideClick={true}
        width={800}
        modalStyle={{ top: 200 }}
        destroyOnClose={true}
      >
        <BankAccountRequest
          setIsModalVisible={setIsModalVisible}
        />
      </ModalComponent>
    </div>
  );
};

export default BankAccountList;
